import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { baseAPI } from '../../../config';
import userStore from '../../../store/userStore';
import InteractionItem from '../../ManagementListPage/components/InteractionItem/InteractionItem';

const InteractionsExpedient = ({ expedient }) => {
  const [expedientid] = useState(expedient._id);
  const [interactions, setInteractions] = useState([]);
  // Hasta que llega la respuesta no se sabe si hay o no: decir «No hay» mientras
  // carga es decir algo falso durante unos segundos.
  const [loading, setLoading] = useState(true);
  const { user } = userStore();

  const loadInteractions = useCallback(async () => {
    try {
      const response = await axios.get(`${baseAPI}/interactions/${expedientid}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      response.data.sort((a, b) => new Date(b.date) - new Date(a.date));
      setInteractions(response.data);
    } catch (error) {
      console.error('Error fetching interactions:', error);
    } finally {
      setLoading(false);
    }
  }, [expedientid]);

  useEffect(() => {
    if (user) {
      try {
        loadInteractions();
      } catch (error) {
        console.error('Error fetching interactions:', error);
      }
    }
  }, [expedientid, user, loadInteractions]);

  return (
    <div className='col-span-full xl:col-span-8 bg-white shadow-lg rounded-lg border border-gray-200'>
      <header className='px-5 py-4 border-b border-gray-100'>
        <h2 className='font-semibold text-gray-800'>
          Interacciones <span className='text-gray-400 font-medium'>{interactions.length}</span>
        </h2>
      </header>
      <div className='p-6 max-w-[1200px] mx-auto'>
        {loading ? (
          <p className='text-sm text-gray-500 text-center py-8'>Cargando…</p>
        ) : interactions.length > 0 ? (
          <div className='space-y-0'>
            {interactions.map((interaction, index) => (
              <InteractionItem
                key={interaction._id || interaction.interaction_id || index}
                interactionItem={interaction}
                isLast={index === interactions.length - 1}
                expedientId={expedientid}
              />
            ))}
          </div>
        ) : (
          <p className='text-sm text-gray-500 text-center py-8'>No hay interacciones disponibles.</p>
        )}
      </div>
    </div>
  );
};

export default InteractionsExpedient;
